import React, { FunctionComponent } from 'react'

import {
  FreeTextQuestion,
  IntegerQuestion,
  OneOfManyQuestion,
  CountryQuestion,
  MovieQuestion,
  QuestionType,
  questionHasChoiceList,
} from '@models/Survey'
import { AnswerProps } from './AnswerProps'
import FreeTextInput from './FreeTextInput/FreeTextInput'
import MusicInput from './MusicInput/MusicInput'
import OneOfManyInput from './OneOfManyInput/OneOfManyInput'
import IntegerInput from './IntegerInput/IntegerInput'
import CountryInput from './CountryInput/CountryInput'
import MovieInput from './MovieInput/MovieInput'
import { BookQuestion, CanadianPostalCodeQuestion, PostalCodeQuestion, TacticalQuestion } from '@models/Survey/Survey'
import { CanadianPostalCodeInput } from '@components/AnswerInput/CanadianPostalCodeInput/CanadianPostalCodeInput'
import PostalCodeInput from '@components/AnswerInput/PostalCodetInput/PostalCodeInput'
import OneOfManyGraphicInput from './OneOfManyGraphicInput/OneOfManyGraphicInput'
import BookInput from './BookInput/BookInput'
import { MovieEntry } from '@models/Movie'
import { BookEntry } from '@models/Book'

const AnswerInput: FunctionComponent<AnswerProps> = ({ question, answer, onSelection }: AnswerProps) => {
  switch (question.type) {
    case QuestionType.FreeText:
      if (questionHasChoiceList(question)) {
        return (
          <OneOfManyInput
            answer={answer}
            onSelection={onSelection}
            question={question as OneOfManyQuestion}
          />
        )
      }
      return <FreeTextInput answer={answer} question={question as FreeTextQuestion} onSelection={onSelection} />
    case QuestionType.PostalCode:
      return <PostalCodeInput answer={answer} question={question as PostalCodeQuestion} onSelection={onSelection} />
    case QuestionType.CanadianPostalCode:
      return (
        <CanadianPostalCodeInput
          question={question as CanadianPostalCodeQuestion}
          answer={answer}
          onSelection={onSelection}
        />
      )
    case QuestionType.Music:
      return <MusicInput />
    case QuestionType.OneOfMany:
      return <OneOfManyInput answer={answer} onSelection={onSelection} question={question as OneOfManyQuestion} />
    case QuestionType.Tactical:
      return <OneOfManyInput answer={answer} onSelection={onSelection} question={question as TacticalQuestion} />
    case QuestionType.Integer:
      return <IntegerInput answer={answer} question={question as IntegerQuestion} onSelection={onSelection} />
    case QuestionType.Country:
      return <CountryInput answer={answer} question={question as CountryQuestion} onSelection={onSelection} />
    case QuestionType.Movie:
      return <MovieInput answer={answer as MovieEntry} question={question as MovieQuestion} onSelection={onSelection} />
    case QuestionType.Book:
      return <BookInput answer={answer as BookEntry} question={question as BookQuestion} onSelection={onSelection} />
    case QuestionType.OneOfManyGraphic:
      return <OneOfManyGraphicInput onSelection={onSelection} />
    default:
      return <> unimplemented questionType {question.type}</>
  }
}

export default AnswerInput
